import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';

const MemberShipEmptyState = ({ onResetFilters }) => (
  <Card mt={4}>
    <Box mb={3} font="h4-regular">
      {__('No matches found based on your search criteria.')}
    </Box>
    <Button
      dataTestId="no-matches-filters-clear"
      onClick={onResetFilters}
      size="large"
    >
      {__('Clear all filters')}
    </Button>
  </Card>
);

export default MemberShipEmptyState;
